import { Block } from "../objects/block";

export function findBlockRecursively(blocks: Block<any>[], id: number): Block<any> | undefined {
    for (const block of blocks) {
        const result = block.findBlock(id);
        if (result) {
            return result;
        }
    }
}